<template>
  <form class="w-full">
    <div class="grid grid-cols-1">
      <div class="col-span-1 pb-6 text-gray-900 dark:text-gray-300" style="min-height: 200px;">
        <QuillEditor theme="snow"
                     v-model:content="form.text"
                     :contentType="'html'"
                     :placeholder="'Ziņa'"
                     :toolbar="[[{ 'size': ['small', false, 'large'] }, 'bold', 'italic', 'underline', 'list'], ['link', 'image']]"
        />
        <template v-if="errors.text">
          <div class="text-red-700 py-3">
            <p v-for="(error, index) in errors.text" :key="index">{{ error }}</p>
          </div>
        </template>
      </div>
      <div class="col-span-1 pt-6">
        <Checkbox
          class="md:mt-8"
          text="Svarīga ziņa"
          v-model="form.is_urgent"
        />
      </div>
    </div>

    <div
      class="
        md:flex-shrink-0
        flex
        items-center
        flex-wrap
        ml-auto
        gap-3
        justify-end
        pt-4
      "
    >
      <template v-if="!loading">
        <button
          type="button"
          class="
            flex
            justify-center
            py-2
            px-4
            border border-transparent
            rounded-md
            shadow-sm
            text-sm
            font-medium
            text-white
            bg-gradient-to-r
            from-button2-from
            to-button2-to
            hover:from-button2-to hover:to-button2-from
            focus:outline-none focus:border-none
            transition
            duration-500
            ease-in-out
          "
          @click.prevent="submit"
        >
          Saglabāt
        </button>
      </template>
      <template v-else>
        <Loading />
      </template>

      <button
        @click.prevent="$store.dispatch('removeAllFormsForDisplay')"
        type="button"
        class="
          inline-flex
          items-center
          px-4
          py-2
          border border-gray-300
          dark:border-gray-500
          shadow-sm
          text-sm
          font-medium
          rounded-md
          text-gray-700
          dark:text-gray-300
          bg-white
          dark:bg-gray-750
          hover:bg-gray-50
          dark:hover:bg-gray-770
          focus:outline-none focus:ring-0
        "
      >
        Atcelt
      </button>
    </div>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import Checkbox from "@/components/Components/Checkbox";
import Validation from "@/modules/Validation";
import Loading from "@/components/Components/Loading";

import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';

export default {
  name: "AddMessage",
  components: {
    QuillEditor,
    Checkbox,
    Loading,
  },
  props: {
      component: {
          type: Object
      }
  },
  data() {
    return {
      form: {
        text: null,
        is_urgent: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      errors: "errors",
      loading: "loading",
    }),
    formValidation() {
      return {
        text: {
          rules: ["required"],
        },
      };
    },
  },
  methods: {
    submit() {
      this.$Progress.start();
      if (Validation(this.formValidation, this.form)) {
        this.$store.dispatch("createNewMessage", {id: this.component.id, data: this.form});
      } else {
        this.$Progress.fail();
      }
    },
  },
};
</script>
<style scoped>
</style>